export default __webpack_public_path__ + "static/media/i-finalizado_bcr.605a70c9.svg";